import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArchiveIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M15.5 3C16.6046 3 17.5 3.89543 17.5 5V7C17.5 7.55228 17.0523 8 16.5 8V15C16.5 16.1046 15.6046 17 14.5 17H5.5C4.39543 17 3.5 16.1046 3.5 15V8C2.94772 8 2.5 7.55228 2.5 7V5C2.5 3.96435 3.28722 3.113 4.2959 3.01074L4.5 3H15.5ZM5 15C5 15.2761 5.22386 15.5 5.5 15.5H14.5C14.7761 15.5 15 15.2761 15 15V8H5V15ZM11.75 9.5C12.1642 9.5 12.5 9.83579 12.5 10.25C12.5 10.6642 12.1642 11 11.75 11H8.25C7.83579 11 7.5 10.6642 7.5 10.25C7.5 9.83579 7.83579 9.5 8.25 9.5H11.75ZM4.5 4.5C4.22386 4.5 4 4.72386 4 5V6.5H16V5C16 4.72386 15.7761 4.5 15.5 4.5H4.5Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArchiveIcon;
